import { frenchFormat } from '@gozoki/tools'

export const formatEuro = (value: number): string => `${frenchFormat(Math.round(value))} €`
export const formatEuroCents = (value: number): string =>
  `${value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`
export const formatInt = (value: number): string => Math.round(value).toLocaleString('fr-FR')
export const formatPercent = (value: number, digits = 1): string =>
  `${value.toLocaleString('fr-FR', { minimumFractionDigits: digits, maximumFractionDigits: digits })} %`
